import { Box, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import { Img } from "@storybook/components";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroupsPropsExternalTrainings } from "./ButtonGroupsExternalTrainings.types";
// import deleteIcon from "../../assets/Elimina.svg";
import ButtonCst from "../ButtonCst";




export const ButtonGroupsExternalTrainings: React.FC<ButtonGroupsPropsExternalTrainings> = ({ onClickDelete, onClickCancel, onClickConfirm, isPending, isCourseSelected }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isCustomSize = useMediaQuery("(max-width: 1350px)");
  


  return (
    <Box
      sx={ {
        display: "flex",
        mt: "10px",
        flex: "1 1",
        flexDirection: "center",
        justifyContent: "space-between",
        gap: isMobile ? 1 : 0,
        pt: 2
      } }
    >
      <Box
        sx={ {
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-end",
          width: isMobile ? "100%" : "auto",
          gap: 1 ,
          flexDirection: isCustomSize ? "column" : "row"
        } }
      >
        { !isCourseSelected && <Button 
          variant={ "text" } 
          size={ "small" } 
          disabled={ !isPending } 
          onClick={ onClickDelete } 
          sx={ {
            display: "flex",
            justifyContent: isMobile ? "center" : "flex-end",
            width: isMobile ? "100%" : "auto",
            color: theme.customColors.backgroundPrimaryCta,
            fontWeight: "bold",
            textDecoration: "underline",
            textTransform: "none",
            minWidth: "unset",
            paddingLeft: 2,
            paddingBottom: 2,
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline"
            },
            "&.Mui-disabled": {
              color: theme.customColors.textDisabledAlternative,
              borderColor: theme.customColors.border
            }
          } }
        >
          { t("delete") }
        </Button> }
        
      </Box>
      <Box
        sx={ {
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-end",
          width: isMobile ? "100%" : "auto",
          gap: 1 ,
          flexDirection: isCustomSize ? "column" : "row"
        } }
      >
        { !isCourseSelected && <ButtonCst
          id="cancel"
          variant={ "outlined" }
          size="small"
          sx={ {
            borderRadius: "8px",
            minWidth: "120px",
            mb: "10px",
            backgroundColor: "transparent",
            opacity: 1,
            "&.Mui-disabled": {
              color: theme.customColors.textDisabledAlternative,
              borderColor: theme.customColors.border
            },
            [theme.breakpoints.down("lg")]: {
              minWidth: "100px"
            },
            [theme.breakpoints.down("sm")]: {
              minWidth: "100%"
            }
          } }
          onClick={ onClickCancel }
          disabled={ !isCourseSelected && !isPending }
        >
          { t("annul") }
        </ButtonCst> }
        { !isCourseSelected && <ButtonCst
          id={ "confirm" }
          variant={ "contained" }
          size={ "small" }
          sx={ {
            borderRadius: "8px",
            minWidth: "150px",
            mb: "10px",
            opacity: 1,
            "&.Mui-disabled": {
              color: theme.customColors.textDisabledAlternative,
              borderColor: theme.customColors.border
            },
            [theme.breakpoints.down("lg")]: {
              minWidth: "100px"
            },
            [theme.breakpoints.down("sm")]: {
              minWidth: "100%"
            }
          } }
          onClick={ onClickConfirm }
          disabled={ isCourseSelected }
        >
          { t("confirm") }
        </ButtonCst> }
      </Box>
    </Box>
  );
};
